
import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo-section">
            <img src="/logos/logo_color_transparente.png" alt="ProCam360 Logo" className="logo" />
            <span className="slogan">Tu opción en cabinas 360</span>
          </Link>

          <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
            <ul>
              <li><Link to="/" className={isActive('/') ? 'active' : ''}>Inicio</Link></li>
              <li><Link to="/servicios" className={isActive('/servicios') ? 'active' : ''}>Servicios</Link></li>
              <li><Link to="/portafolio" className={isActive('/portafolio') ? 'active' : ''}>Portafolio</Link></li>
              <li><Link to="/contacto" className={isActive('/contacto') ? 'active' : ''}>Contacto</Link></li>
            </ul>
          </nav>

          <button 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
